import React, { FC } from 'react';
import useToggle from 'hooks/use-toggle';
import { CategoryTreeInterface } from 'modules/shared/components/category-tree';
import CategoryTreeItem from 'modules/shared/components/category-tree/components/components';

import './category-tree-list.scss';

interface CategoryTreeListProps {
    list: CategoryTreeInterface[];
    limitItems?: number;
    showAllLink?: string;
}

const CategoryTreeList: FC<CategoryTreeListProps> = ({ list, limitItems, showAllLink }) => {
    const [isShowMore, setIsShowMore] = useToggle();

    return (
        <ul>
            {list.slice(0, !isShowMore ? limitItems : void 0).map(item => (
                <CategoryTreeItem
                    key={item.id}
                    name={item.name}
                    url={item.url}
                    isActive={item.active}
                    amount={item.amount}
                />
            ))}
            {limitItems && list.length > limitItems && !isShowMore && (
                <li
                    className="category-tree-list__item--show-more"
                >
                    {React.createElement(!showAllLink ? 'span' : 'a', {
                        href: showAllLink || void 0,
                        onClick: !showAllLink ? setIsShowMore.toggle : void 0
                    }, (
                        !showAllLink ? `Rozwiń wszystkie (${list.length - limitItems})` : 'Zobacz pozostałe'
                    ))}
                </li>
            )}
        </ul>
    );
};

export default CategoryTreeList;
